<template>
  <div class="user-main">
    <UserButtonNew/>
    <div class="table">
      <div class="table-header">
        <div class="table-header-username">
          ユーザーID
        </div>

        <div class="table-header-created-at">
          登録日
        </div>

        <div class="table-header-country">
          国
        </div>

        <div class="table-header-prefecture">
          都道府県
        </div>

        <div class="table-header-tel">
          電話番号
        </div>

        <div class="table-header-name">
          名前
        </div>

        <div class="table-header-birthday">
          生年月日
        </div>

        <div class="table-header-email">
          メールアドレス
        </div>

        <div class="table-header-action">
          アクション
        </div>
      </div>

      <div
        v-for="(user, index) in users"
        :key="index"
        class="table-cell"
        @click="editUser(user)"
        >

        <div class="table-cell-username">
          {{ user.id }}
        </div>

        <div class="table-cell-created-at">
          {{ $store.getters['date/createdAt'](user) }}
        </div>

        <div class="table-cell-country">
          {{ country(user) }}
        </div>

        <div class="table-cell-prefecture">
          {{ prefecture(user) }}
        </div>

        <div class="table-cell-tel">
          {{ user.get('tel') }}
        </div>

        <div class="table-cell-name">
          {{ user.get('name') }}
        </div>

        <div class="table-cell-birthday">
          {{ $store.getters['date/birthDay'](user) }}
        </div>

        <div class="table-cell-email">
          {{ user.get('username') }}
        </div>

        <div class="table-cell-action">
          <div class="icons">
            <icon-bank :user="user" />
            <icon-message :user="user" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UserButtonNew from '@/components/User/ButtonNew'
import IconBank from '@/components/User/IconBank'
import IconMessage from '@/components/User/IconMessage'

export default {
  components: {
    UserButtonNew,
    IconBank,
    IconMessage,
  },

  computed: {
    ...mapState('user', [
      'users'
    ])
  },

  methods: {
    country: function (user) {
      let country = user.get('country')
      if (country) {
        return country.get('ja')
      }
      return ''
    },

    prefecture: function (user) {
      let prefecture = user.get('prefecture')
      if (prefecture) {
        return prefecture.get('ja')
      }
      return ''
    },

    editUser: function (user) {
      this.$router.push({
        name: 'user-edit',
        params: { id: user.id }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin cell {
  &-username {
    padding: 5px;
    width: 10%;
  }

  &-created-at {
    padding: 5px;
    width: 10%;
  }

  &-country {
    padding: 5px;
    width: 10%;
  }

  &-prefecture {
    padding: 5px;
    width: 10%;
  }

  &-tel {
    padding: 5px;
    width: 15%;
  }

  &-name {
    padding: 5px;
    width: 15%;
  }

  &-birthday {
    padding: 5px;
    width: 10%;
  }

  &-email {
    padding: 5px;
    width: 15%;
  }

  &-action {
    padding: 5px;
    width: 15%;
  }
}

@import '@/styles/_table.scss';
@import '@/styles/_icon.scss';
</style>
